
var faqPage = {

    select: document.getElementById('cnfsd-faq-sel'),
    accordionGroups: document.querySelectorAll('div.mod-accordion'),
    sectionHeading: document.getElementById('cndsf-faq-subheader'),
    showMoreButton: document.querySelector('a.mod-accordion__show-more'),
    selectedAccordionGroup: null,
    selectedAccordions: null,

    init: function () {
        faqPage.showMoreButton.addEventListener('click', function (e) {
            e.preventDefault();
            faqPage.toggleShowMore(e);
        });

        faqPage.select.addEventListener('change', function (e) {
            faqPage.handleSelectOnChange(e.target);
        });

        faqPage.handleSelectOnChange(faqPage.select);
    },

    handleSelectOnChange: function (select) {
        //SET HEADING OF FAQ SECTION
        faqPage.sectionHeading.innerHTML = select.value;

        //SET THE SELECTED GROUP OF ACCORDIONS DEPENDING ON THE SELECT INPUT VALUE
        faqPage.selectedAccordionGroup = faqPage.accordionGroups[select.selectedIndex];


        if (!faqPage.selectedAccordionGroup) {
            //HIDE ALL ACCORDION GROUPS IF NO ACCORDIONS EXIST
            Array.prototype.forEach.call(faqPage.accordionGroups, function (accordion) {
                accordion.style.display = 'none';
            });
            return;
        }

        faqPage.selectedAccordions = faqPage.selectedAccordionGroup.querySelectorAll('.mod-accordion__item');

        //LOOP THROUGH ACCORDION GROUPS, IF IS/NOT SELECTED ACCORDION GROUP, SHOW/HIDE GROUP
        Array.prototype.forEach.call(faqPage.accordionGroups, function (group) {
            if (group !== faqPage.selectedAccordionGroup) {
                group.style.display = 'none';
                return;
            }
            group.style.display = '';
        });
        faqPage.displayShowMoreButton();
        faqPage.resetAccordions();
    },

    resetAccordions: function () {
        Array.prototype.forEach.call(faqPage.selectedAccordions, function (accordion, i) {
            if (i >= 4) {
                accordion.style.display = 'none';
            }
        });
    },

    toggleShowMore: function () {
        Array.prototype.forEach.call(faqPage.selectedAccordions, function (accordion) {
            accordion.style.display = '';
        });

        faqPage.showMoreButton.style.display = 'none';
    },

    displayShowMoreButton: function () {
        if (faqPage.selectedAccordions.length > 4) {
            faqPage.showMoreButton.style.display = '';
        } else {
            faqPage.showMoreButton.style.display = 'none';
        }
    }
};


document.addEventListener('DOMContentLoaded', function () {
    var faqSelectExists = document.getElementById('cnfsd-faq-sel');
    if (faqSelectExists) {
        faqPage.init();
    }
});